/** Basic email check (UI-level; server remains authoritative). */
import i18n from "@/i18n/i18n";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateRequiredName(value: string, label = "Name"): string | null {
  if (!value.trim()) return i18n.t("validation.nameRequired", { label });
  return null;
}

export function validateEmailRequired(value: string): string | null {
  const t = value.trim();
  if (!t) return i18n.t("validation.emailRequired");
  if (!EMAIL_RE.test(t)) return i18n.t("validation.emailInvalid");
  return null;
}

/** Empty is OK; if filled, must look like a phone. */
export function validateOptionalPhone(value: string): string | null {
  const t = value.trim();
  if (!t) return null;
  const digits = t.replace(/\D/g, "");
  if (digits.length < 6 || digits.length > 15) return i18n.t("validation.phoneInvalid");
  return null;
}

/** Compare "HH:mm" 24h strings; returns negative if a < b, zero if equal, positive if a > b. */
export function compareTimeHHmm(a: string, b: string): number {
  const [ah, am] = a.split(":").map(Number);
  const [bh, bm] = b.split(":").map(Number);
  const ac = (ah || 0) * 60 + (am || 0);
  const bc = (bh || 0) * 60 + (bm || 0);
  return ac - bc;
}

export function validatePositiveInt(value: number, label: string, min = 1): string | null {
  if (!Number.isFinite(value) || value < min) return i18n.t("validation.fieldAtLeast", { label, min });
  return null;
}

export function validateNonNegativeInt(value: number, label: string): string | null {
  if (!Number.isFinite(value) || value < 0) return i18n.t("validation.fieldNonNegative", { label });
  return null;
}

export function validatePriceString(value: string): { ok: true; cents: number } | { ok: false; message: string } {
  const t = value.trim();
  if (!t) return { ok: false, message: i18n.t("validation.priceRequired") };
  const n = parseFloat(t.replace(",", "."));
  if (!Number.isFinite(n)) return { ok: false, message: i18n.t("validation.priceInvalid") };
  const cents = Math.round(n * 100);
  if (cents < 0) return { ok: false, message: i18n.t("validation.priceNegative") };
  return { ok: true, cents };
}
